import React from 'react';
import { Form, Button } from 'semantic-ui-react';
import ReactDatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { FormattedMessage, useIntl } from 'react-intl';
import Loader from 'components/loaders/Loader';
import { useBookingHistoryContext } from '../BookingHistory/BookingHistoryContext';
import styles from './styles.module.scss';
import { downloadCsv } from './utils';

const MonthPickerButton = React.forwardRef(({ value, onClick }, ref) => (
  <button
    type="button"
    className={styles.datePickerButton}
    onClick={onClick}
    ref={ref}
  >
    {value}
  </button>
));

export const BookingHistoryFiltersAndExport = () => {
  const {
    bookingHistory,
    selectedDate,
    setSelectedDate,
    selectedResourceType,
    setSelectedResourceType,
    isFetching,
  } = useBookingHistoryContext();

  const intl = useIntl();

  if (isFetching) return <Loader />;

  const resourceTypeOptions = [
    { key: 'all', value: '', text: intl.formatMessage({ id: 'allResourceTypes' }) },
    { key: 'laundry', value: 'Laundry', text: intl.formatMessage({ id: 'laundry' }) },
    { key: 'apartment', value: 'Apartment', text: intl.formatMessage({ id: 'apartment' }) },
  ];
  return (
    <>
      <div className={styles.filters}>
        <Form.Group className={styles.fields}>
          <Form.Field className={styles.field}>
            <label>
              <FormattedMessage id="selectMonth" />
            </label>
            <ReactDatePicker
              selected={selectedDate}
              onChange={(date) => setSelectedDate(date || new Date())}
              dateFormat="MMMM yyyy"
              showMonthYearPicker
              showFullMonthYearPicker
              customInput={<MonthPickerButton />}
            />
          </Form.Field>

          <Form.Field className={styles.field}>
            <label>
              <FormattedMessage id="resourceType" />
            </label>
            <div className={styles.resourceTypeToggle}>
              {resourceTypeOptions.map((option) => {
                const isActive = selectedResourceType === option.value;

                return (
                  <Button
                    key={option.key}
                    type="button"
                    size="small"
                    basic={!isActive}
                    onClick={() => setSelectedResourceType(option.value)}
                  >
                    {option.text}
                  </Button>
                );
              })}
            </div>
          </Form.Field>
        </Form.Group>
      </div>

      <div className={styles.actions}>
        <Button
          type="button"
          onClick={() => downloadCsv(bookingHistory)}
        >
          <FormattedMessage id="exportCsv" />
        </Button>
      </div>
    </>
  );
};
